// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

// const context = require.context("controllers", true, /_controller\.js$/)
import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)
import TopbarController from "./topbar_controller"
application.register("topbar", TopbarController)
